import React from 'react'
import PropTypes from 'prop-types'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import { useEnvValue } from '@morningtrain/react-helpers'
import DateFilter from 'support/filters/DateFilter'
import { StaticFilter } from '@morningtrain/react-filters'

export default function DateFilterSyncedWithEnv (props) {
  const defaultPeriod = props.defaultDate || moment()

  const [envValue] = useEnvValue(props.envName, defaultPeriod)

  return (
    <>
      <StaticFilter name={props.name} value={moment(defaultPeriod).format('YYYY-MM-DD')} />
      <DateFilter key={moment(envValue).format('YYYY-MM-DD')} name={props.name} defaultValue={envValue} label={props.label} />
    </>
  )
}

DateFilterSyncedWithEnv.propTypes = {
  name: PropTypes.string.isRequired,
  envName: PropTypes.string.isRequired
}
